module.exports = __webpack_public_path__ + "img/EXPORT.c81cbcfd.svg";